import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";

import { Button } from "@ps-design-system/components/Button";
import { Text } from "@ps-design-system/components/Text";

import { selectProfileSSOid } from "../../../app-main/selectors/profile.selectors";
import { trackUpcomingViewAllClicked } from "../../analytics/host-hub-analytics";
import useHostHubUpcomingBookings from "../../hooks/useHostHubUpcomingBookings";
import { handleCalendarClick } from "../../utils/host-hub-upcoming-panel.utils";

const HostHubUpcomingPanelHeader = () => {
  const ssoid = useSelector(selectProfileSSOid);
  const { bookings } = useHostHubUpcomingBookings();
  const hasUpcomingBookings = bookings.length > 0;

  const headerActionLabel = hasUpcomingBookings ? (
    <FormattedMessage
      defaultMessage="View all"
      id="host_hub.upcoming.view_all"
    />
  ) : (
    <FormattedMessage
      defaultMessage="View calendar"
      id="host_hub.upcoming_panel.view_calendar"
    />
  );

  const handleClick = () => {
    if (hasUpcomingBookings) {
      trackUpcomingViewAllClicked({ ssoid });
    }
    handleCalendarClick();
  };

  return (
    <div className="tw-flex tw-items-center tw-justify-between tw-gap-[16px]">
      <Text className="tw-my-0" element="h2" typeface="headline-3-m">
        <FormattedMessage
          defaultMessage="Upcoming"
          id="host_hub.upcoming.title"
        />
      </Text>
      <Button onClick={handleClick} variant="underline-m">
        {headerActionLabel}
      </Button>
    </div>
  );
};

export default HostHubUpcomingPanelHeader;
